import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface SearchResult {
  id: string;
  name: string;
  phone: string;
  type: 'contact' | 'lead';
}

export function useDialerSearch(query: string) {
  const [results, setResults] = useState<SearchResult[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const searchContactsAndLeads = async () => {
      if (!query || query.length < 2) {
        setResults([]);
        return;
      }

      setLoading(true);
      try {
        // Use RPC function for accent-insensitive search
        const { data, error } = await supabase
          .rpc('search_dialer_unaccent', {
            search_term: query,
            max_results: 20
          });

        if (error) throw error;

        // Map results to expected format
        const formattedResults: SearchResult[] = (data || []).map((item: any) => ({
          id: item.id,
          name: item.name || 'Sem nome',
          phone: item.phone || '',
          type: item.record_type as 'contact' | 'lead',
        }));

        setResults(formattedResults);
      } catch (error) {
        console.error("Error searching contacts/leads:", error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    const timeoutId = setTimeout(() => {
      searchContactsAndLeads();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [query]);

  return { results, loading };
}
